class QuestionType {
	static DragAndDrop = "DragnDrop";
	static FreeText = "FreeText";
	static TrueFalse = "TrueFalse";
	static HotSpot = "Hotspot";
	static RadioButton = "Radio";
	static Checkbox = "Checkbox";
	static SingleSelect = "SingleSelect";
	static MultiSelect = "MultiSelect";
	static FillInTheBlanks = "Blanks";
	static WordProcessor = "Word";
	static ExcelProcessor = "Excel";
	static MultiResponse = "MultiResponse";
}

class QuestionTypeText {
	static [QuestionType.DragAndDrop] = "Drag & Drop";
	static [QuestionType.FreeText] = "Free Text";
	static [QuestionType.HotSpot] = "Hotspot";
	static [QuestionType.RadioButton] = "Radio Button";
	static [QuestionType.Checkbox] = "Checkbox";
	static [QuestionType.SingleSelect] = "Single-select";
	static [QuestionType.MultiSelect] = "Multi-select";
	static [QuestionType.FillInTheBlanks] = "Fill in the Blanks";
	static [QuestionType.WordProcessor] = "Word Processor";
	static [QuestionType.ExcelProcessor] = "Excel Processor";
	static [QuestionType.MultiResponse] = "Multi-response";
	static [QuestionType.TrueFalse] = "True False";
}

class QuestionDifficultyLevel {
	static EASY = "Easy";
	static INTERMEDIATE = "Intermediate";
	static DIFFICULT = "Difficult";
	static VERY_DIFFICULT = "Very Difficult";
}
const questionDifficultyLevelOptions = [
	{
		label: "Easy",
		value: QuestionDifficultyLevel.EASY,
	},
	{
		label: "Intermediate",
		value: QuestionDifficultyLevel.INTERMEDIATE,
	},
	{
		label: "Difficult",
		value: QuestionDifficultyLevel.DIFFICULT,
	},
	{
		label: "Very Difficult",
		value: QuestionDifficultyLevel.VERY_DIFFICULT,
	},
];

const sampleQuestions = [
	{
		QuestionID: 12,
		SourceID: null,
		QuestionGroupID: null,
		QuestionGroupSequence: null,
		QuestionText: "<p>What is the color of the sky?</p>",
		RequirementsText: null,
		QuestionTitle: "New Test Question",
		QuestionType: {
			QuestionTypeID: 4,
			QuestionTypeName: "Radio",
		},
		QuestionUsedStatus: false,
		QuestionMarks: 0.0,
		DifficultyLevel: null,
		Answers: [
			{
				AnswerID: 36,
				AnswerText: "<p>Yellow</p>",
				ExtraFields: '""',
				IsCorrect: false,
			},
			{
				AnswerID: 37,
				AnswerText: "<p>Green</p>",
				ExtraFields: '""',
				IsCorrect: false,
			},
			{
				AnswerID: 38,
				AnswerText: "<p>Blue</p>",
				ExtraFields: '""',
				IsCorrect: false,
			},
			{
				AnswerID: 39,
				AnswerText: "<p>Red</p>",
				ExtraFields: '""',
				IsCorrect: false,
			},
			{
				AnswerID: 40,
				AnswerText: "<p>Pink</p>",
				ExtraFields: '""',
				IsCorrect: false,
			},
		],
		CreatedBy: {
			userID: 5,
			FirstName: "Hanan",
			LastName: "Bhai",
			Email: "hanan@ets.com",
		},
		Categories: [
			{
				CategoryID: 2,
				CategoryName: "Semester 2",
				SourceID: "category2",
				ParentID: null,
			},
		],
		CreatedAt: "2022-04-18T11:00:32+00:00",
		UpdatedAt: null,
		DeletedAt: null,
	},
	{
		questionID: "001",
		questionGroupID: null,
		questionGroupSequence: null,
		questionText:
			"<p>When a parent is evaluating the assets of a potential subsidiary, certain intangible assets can be recognised separately from goodwill, even though they have not been recognised in the subsidiary's own statement of financial position.</p><h4>Which of the following is an example of an intangible asset of the subsidiary that may be recognised separately from goodwill when preparing consolidated financial statements?</h4>",
		requirementsText: null,
		questionTitle: "Question 1",
		isPrivate: 0,
		questionType: {
			questionTypeID: 1,
			questionTypeName: "Radio",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText:
					"A new research project which the subsidiary has correctly expensed to profit or loss but the directors of the parent have reliably assessed to have a substantial fair value",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 2,
				answerText:
					"A global advertising campaign which was concluded in the previous financial year and from which benefits are expected to flow in the future",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 3,
				answerText:
					"A customer list which the directors are unable to value reliably",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 4,
				answerText:
					"A contingent asset of the subsidiary from which the parent believes a flow of future economic benefits is possible",
				extraFields: null,
				isCorrect: true,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestiingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
	{
		questionID: "002",
		questionGroupID: null,
		questionGroupSequence: null,
		questionText:
			"<p>When a parent is evaluating the assets of a potential subsidiary, certain intangible assets can be recognised separately from goodwill, even though they have not been recognised in the subsidiary's own statement of financial position.</p><h4>Which of the following is an example of an intangible asset of the subsidiary that may be recognised separately from goodwill when preparing consolidated financial statements?</h4>",
		requirementsText: null,
		questionTitle: "Question 2",
		isPrivate: 0,
		questionType: {
			questionTypeID: 3,
			questionTypeName: "Checkbox",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText:
					"A new research project which the subsidiary has correctly expensed to profit or loss but the directors of the parent have reliably assessed to have a substantial fair value",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 2,
				answerText:
					"A global advertising campaign which was concluded in the previous financial year and from which benefits are expected to flow in the future",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 3,
				answerText:
					"A customer list which the directors are unable to value reliably",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 4,
				answerText:
					"A contingent asset of the subsidiary from which the parent believes a flow of future economic benefits is possible",
				extraFields: null,
				isCorrect: true,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestiingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
	{
		questionID: "003",
		questionGroupID: null,
		questionGroupSequence: null,
		questionText:
			"<p>When a parent is evaluating the assets of a potential subsidiary, certain intangible assets can be recognised separately from goodwill, even though they have not been recognised in the subsidiary's own statement of financial position.</p><h4>Which of the following is an example of an intangible asset of the subsidiary that may be recognised separately from goodwill when preparing consolidated financial statements?</h4>",
		requirementsText: null,
		questionTitle: "Question 3",
		isPrivate: 0,
		questionType: {
			questionTypeID: 2,
			questionTypeName: "SingleSelect",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText:
					"A new research project which the subsidiary has correctly expensed to profit or loss but the directors of the parent have reliably assessed to have a substantial fair value",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 2,
				answerText:
					"A global advertising campaign which was concluded in the previous financial year and from which benefits are expected to flow in the future",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 3,
				answerText:
					"A customer list which the directors are unable to value reliably",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 4,
				answerText:
					"A contingent asset of the subsidiary from which the parent believes a flow of future economic benefits is possible",
				extraFields: null,
				isCorrect: true,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestiingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
	{
		questionID: "004",
		questionGroupID: null,
		questionGroupSequence: null,
		questionText:
			"<p>When a parent is evaluating the assets of a potential subsidiary, certain intangible assets can be recognised separately from goodwill, even though they have not been recognised in the subsidiary's own statement of financial position.</p><h4>Which of the following is an example of an intangible asset of the subsidiary that may be recognised separately from goodwill when preparing consolidated financial statements?</h4>",
		requirementsText: null,
		questionTitle: "Question 4",
		isPrivate: 0,
		questionType: {
			questionTypeID: 2,
			questionTypeName: "MultiSelect",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText:
					"A new research project which the subsidiary has correctly expensed to profit or loss but the directors of the parent have reliably assessed to have a substantial fair value",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 2,
				answerText:
					"A global advertising campaign which was concluded in the previous financial year and from which benefits are expected to flow in the future",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 3,
				answerText:
					"A customer list which the directors are unable to value reliably",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 4,
				answerText:
					"A contingent asset of the subsidiary from which the parent believes a flow of future economic benefits is possible",
				extraFields: null,
				isCorrect: true,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestiingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
	{
		questionID: "005",
		questionGroupID: null,
		questionGroupSequence: null,
		questionText:
			"<h4>Match the tokens to the appropriate category based on whether or not the costs should be capitalised in the initial carrying amount of an item of plant.</h4>",
		requirementsText: null,
		questionTitle: "Question 5",
		isPrivate: 0,
		questionType: {
			questionTypeID: 2,
			questionTypeName: "DragnDrop",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText: "",
				extraFields: {
					draggables: [
						{
							id: 1,
							text: "The cost of installing a new power supply required to operate the plant",
						},
						{
							id: 2,
							text: "The cost of a three-year plant maintenance agreement",
						},
						{
							id: 3,
							text: "The cost of transporting the plant to factory",
						},
						{
							id: 4,
							text: "The cost of a three-week training course for staff to operate the plant",
						},
					],
					droppables: [
						{
							id: 1,
							text: null,
							isAnswerOf: 1,
							groupId: 1,
						},
						{
							id: 2,
							text: null,
							isAnswerOf: 2,
							groupId: 1,
						},
						{
							id: 3,
							text: null,
							isAnswerOf: 4,
							groupId: 1,
						},
						{
							id: 4,
							text: null,
							isAnswerOf: 3,
							groupId: 1,
						},
					],
					groups: [
						{
							id: 1,
							groupTitle:
								"The initial carrying amounts of plant should include",
						},
						{
							id: 2,
							groupTitle:
								"The initial carrying amounts of plant should NOT include",
						},
					],
				},
				isCorrect: true,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
	{
		questionID: "006",
		questionGroupID: 1,
		questionGroupSequence: 1,
		questionText:
			"<p>On 1 October 20X4, Pyramid Co acquired 80% of Square Co's 9 million($1) equity shares. At the date of acquisition, Square Co had an itemof plant which had a fair value of $3m in excess of its carryingamount. At the date of acquisition it had a remaining life of fiveyears.</p><p>Pyramid Co's policy is to value non-controlling interests at fairvalue at the date of acquisition. For this purpose, Square Co's shareshad a value of $3.50 each at that date. In the year ended 30 September20X5, Square Co reported a profit of $8m.</p><h4>At what amount should the non-controlling interests of Square Co bevalued in the consolidated statement of financial position of PyramidCo as at 30 September 20X5?</h4>",
		requirementsText:
			"<p>Telepath Co has a year end of 30 September and owns an item of plant that it uses to produce and package pharmaceuticals. The plant cost$750,000 on 1 October 20X0 and, at that date, had an estimated usefullife of five years. A review of the plant on 1 April 20X3 concludedthat the plant would last for a further three and a half years andthat its fair value was $560,000. Telepath Co adopts the policy ofrevaluing its non-current assets to their fair value but does not makean annual transfer from the revaluation surplus to retained earningsto represent the additional depreciation charged due to therevaluation. &nbsp;</p><p>On 30 September 20X3, Telepath Co was informed by a major customerthat it would no longer be placing orders with Telepath Co. As aresult, Telepath Co revised its estimates that net cash inflows earnedfrom the plant for the next three years will be:</p><p>&nbsp;</p><table class='table table-bordered' border='1' cellspacing='0' cellpadding='0'><colgroup class='text-center' width='253'></colgroup><colgroup class='text-center' width='113'></colgroup><tbody><tr><td class='text-center'><p><strong>Year ended 30 September:</strong></p></td><td class='text-center'><strong>$’000</strong><p></p></td></tr><tr><td width='253' class='text-center'><p>20X4</p></td><td width='113' class='text-center'>220<p></p></td></tr><tr><td width='253' class='text-center'><p>20X5</p></td><td width='113' class='text-center'>180<p></p></td></tr><tr><td width='253' class='text-center'><p>20X6</p></td><td width='113' class='text-center'>200<p></p></td></tr></tbody></table><p>Telepath Co’s cost of capital is 10% which results in the followingdiscount factors:</p><p>&nbsp;</p><table class='table table-bordered' border='1' cellspacing='0' cellpadding='0'><colgroup class='text-center' width='253'></colgroup><colgroup class='text-center' width='113'></colgroup><tbody><tr><td><p><strong>Value of $1 at 30 September:</strong></p></td><td class='text-center'><strong>$'000</strong><p></p></td></tr><tr><td width='253' class='text-center'><p>20X4</p></td><td width='113' class='text-center'>0.91<p></p></td></tr><tr><td width='253' class='text-center'><p>20X5</p></td><td width='113' class='text-center'>0.83<p></p></td></tr><tr><td width='253' class='text-center'><p>20X6</p></td><td width='113' class='text-center'>0.75<p></p></td></tr></tbody></table><p>&nbsp;</p><p>Telepath Co also owns Rilda Co, a 100% subsidiary, which is treated asa cash generating unit. On 30 September 20X3, there was an impairmentto Rilda Co's assets of $3,500,000. The carrying amount of the assetsof Rilda Co immediately before the impairment were:</p><table class='table table-bordered' border='1' cellspacing='0' cellpadding='0'><colgroup class='text-center' width='253'></colgroup><colgroup class='text-center' width='77'></colgroup><tbody><tr><td><p><strong>&nbsp;</strong></p></td><td class='text-center'><strong>$'000</strong><p></p></td></tr><tr><td width='253' class='text-center'><p>Goodwill</p></td><td width='77' class='text-center'>2,000<p></p></td></tr><tr><td width='253' class='text-center'><p>Factory building</p></td><td width='77' class='text-center'>4,000<p></p></td></tr><tr><td width='253' class='text-center'><p>Plant</p></td><td width='77' class='text-center'>3,500<p></p></td></tr><tr><td width='253' class='text-center'><p>Receivables and cash (at recoverable amount)</p></td><td width='77' class='text-center'>2,500<p></p></td></tr><tr><td width='253' class='text-center'><p>&nbsp;</p></td><td width='77' class='text-center'><strong>12,000</strong><p></p></td></tr></tbody></table>",
		questionTitle: "Question 6",
		isPrivate: 0,
		questionType: {
			questionTypeID: 6,
			questionTypeName: "SingleSelect",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText: "$26,680,000",
				extraFields: null,
				isCorrect: true,
			},
			{
				answerID: 2,
				answerText: "$7,900,000",
				extraFields: null,
				isCorrect: false,
			},
			{
				answerID: 3,
				answerText: "$7,780,000",
				extraFields: null,
				isCorrect: false,
			},
			{
				answerID: 4,
				answerText: "$12,220,000",
				extraFields: null,
				isCorrect: false,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
	{
		questionID: "007",
		questionGroupID: null,
		questionGroupSequence: null,
		questionText:
			"<div class='wrapper'><p>Question 1</p><p>The following draft financial statements relate to Bubble Group, a public limited company and two<br>other companies in which it owns investments.</p><p>DRAFT STATEMENTS OF FINANCIAL POSITION AS AT 31 OCTOBER 20X5</p><table style='width: 468.975px;'><tbody><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>&nbsp;</td><td style='width: 73px; height: 13px;'>Bubble</td><td style='width: 78px; height: 13px;'>Salt</td><td style='width: 48.975px; height: 13px;'>Tyslar</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>&nbsp;</td><td style='width: 73px; height: 13px;'>$m</td><td style='width: 78px; height: 13px;'>$m</td><td style='width: 48.975px; height: 13px;'>Dinars m</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Assets</td><td style='width: 73px; height: 13px;'>&nbsp;</td><td style='width: 78px; height: 13px;'>&nbsp;</td><td style='width: 48.975px; height: 13px;'>&nbsp;</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Non-current assets</td><td style='width: 73px; height: 13px;'>&nbsp;</td><td style='width: 78px; height: 13px;'>&nbsp;</td><td style='width: 48.975px; height: 13px;'>&nbsp;</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Property, plant and equipment</td><td style='width: 73px; height: 13px;'>280</td><td style='width: 78px; height: 13px;'>105</td><td style='width: 48.975px; height: 13px;'>390</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Investment in Salt</td><td style='width: 73px; height: 13px;'>110</td><td style='width: 78px; height: 13px;'>&nbsp;</td><td style='width: 48.975px; height: 13px;'>&nbsp;</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Investment in Tyslar</td><td style='width: 73px; height: 13px;'>46</td><td style='width: 78px; height: 13px;'>&nbsp;</td><td style='width: 48.975px; height: 13px;'>&nbsp;</td></tr><tr style='height: 40px;'><td style='width: 238px; height: 40px;'>Financial assets</td><td style='width: 73px; height: 40px;'>12<br>––––<br>448</td><td style='width: 78px; height: 40px;'>9<br>–––<br>114</td><td style='width: 48.975px; height: 40px;'>98<br>––––<br>488</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Current assets</td><td style='width: 73px; height: 13px;'>&nbsp;</td><td style='width: 78px; height: 13px;'>&nbsp;</td><td style='width: 48.975px; height: 13px;'>&nbsp;</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Inventories</td><td style='width: 73px; height: 13px;'>20</td><td style='width: 78px; height: 13px;'>12</td><td style='width: 48.975px; height: 13px;'>16</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Trade and other receivables</td><td style='width: 73px; height: 13px;'>30</td><td style='width: 78px; height: 13px;'>25</td><td style='width: 48.975px; height: 13px;'>36</td></tr><tr style='height: 27px;'><td style='width: 238px; height: 27px;'>Cash and cash equivalents</td><td style='width: 73px; height: 27px;'>14<br>––––</td><td style='width: 78px; height: 27px;'>11<br>–––</td><td style='width: 48.975px; height: 27px;'>90<br>––––</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Total assets</td><td style='width: 73px; height: 13px;'>512</td><td style='width: 78px; height: 13px;'>162</td><td style='width: 48.975px; height: 13px;'>630</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Equity and liabilities</td><td style='width: 73px; height: 13px;'>&nbsp;</td><td style='width: 78px; height: 13px;'>&nbsp;</td><td style='width: 48.975px; height: 13px;'>&nbsp;</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Equity shares</td><td style='width: 73px; height: 13px;'>80</td><td style='width: 78px; height: 13px;'>50</td><td style='width: 48.975px; height: 13px;'>210</td></tr><tr style='height: 13px;'><td style='width: 238px; height: 13px;'>Retained earnings</td><td style='width: 73px; height: 13px;'>230</td><td style='width: 78px; height: 13px;'>74</td><td style='width: 48.975px; height: 13px;'>292</td></tr><tr style='height: 27px;'><td style='width: 238px; height: 27px;'>Other components of equity</td><td style='width: 73px; height: 27px;'>40<br>––––</td><td style='width: 78px; height: 27px;'>12<br>–––</td><td style='width: 48.975px; height: 27px;'>––––</td></tr><tr style='height: 27px;'><td style='width: 238px; height: 27px;'>Total equity</td><td style='width: 73px; height: 27px;'>350<br>––––</td><td style='width: 78px; height: 27px;'>136<br>–––</td><td style='width: 48.975px; height: 27px;'>502<br>––––</td></tr><tr style='height: 13.8px;'><td style='width: 238px; height: 13.8px;'>Non-current liabilities</td><td style='width: 73px; height: 13.8px;'>95</td><td style='width: 78px; height: 13.8px;'>7</td><td style='width: 48.975px; height: 13.8px;'>110</td></tr><tr style='height: 27px;'><td style='width: 238px; height: 27px;'>Current liabilities</td><td style='width: 73px; height: 27px;'>67<br>––––</td><td style='width: 78px; height: 27px;'>19<br>–––</td><td style='width: 48.975px; height: 27px;'>18<br>––––</td></tr><tr style='height: 54px;'><td style='width: 238px; height: 54px;'>Total equity and liabilities</td><td style='width: 73px; height: 54px;'>162<br>––––<br>512<br>––––</td><td style='width: 78px; height: 54px;'>26<br>–––<br>162<br>–––</td><td style='width: 48.975px; height: 54px;'>128<br>––––<br>630<br>––––</td></tr></tbody></table><p>The following information is relevant to the Bubble Group.</p><p>(a) Bubble acquired 80% of the equity shares of Salt on 1 November 20X3 when Salt's retained<br>earnings were $56 million and other components of equity were $8 million. The fair value of<br>the net assets of Salt were $120 million at the date of acquisition. This does not include a<br>contingent liability which was disclosed in Salt's financial statements as a possible obligation<br>of $5 million. The fair value of the obligation was assessed as $1 million at the date of<br>acquisition and remained unsettled as at 31 October 20X5, Any remaining difference in the<br>fair value of the net assets at acquisition relates to non-depreciable land. The fair value of the<br>non-controlling interest at acquisition was estimated as $25 million. Bubble always adopts the<br>full goodwill method under IFRS 3 Business Combinations.</p><p>(b) Bubble owns 60% of the equity shares of Tyslar, a company located overseas,which uses the<br>dinar as its functional currency. The shares in Tyslar were acquired on 1 November 20X4 at a<br>cost of 368 million dinars. At the date of acquisition, retained earnings were 258 million<br>dinars and Tyslar had no other components of equity. No fair value adjustments were deemed<br>necessary in relation to the acquisition of Tyslar. The fair value of the non-controlling interest<br>was estimated as 220 million dinars at acquisition. No dividend was paid by Tyslar in the<br>year ended 31 October 20X5.</p><p>(c) An impairment review of goodwill was undertaken as at 31 October 20X5. No impairment<br>was necessary in relation to Salt, but the goodwill of Tyslar is to be impaired by 20%. Neither<br>Bubble, Salt nor Tyslar has issued any equity shares since acquisition.</p><p>(d) On 1 February 20X5, Bubble gave an interest-free loan to Tyslar for $10 million. Tyslar<br>recorded this correctly in its financial statements using the spot rate of exchange. Tyslar repaid<br>$5 million on 1 July 20X5 when the spot exchange rate was $1 to 10 dinars. Tyslar therefore<br>reduced its non-current liabilities by 50 million dinars. No further entries were made in Tyslar's<br>financial statements. The outstanding balance remains within the financial assets of Bubble<br>and the non-current liabilities of Tyslar.</p><p>(e) The following exchange rates are relevant to the preparation of the group financial statements:</p><p>Dinars to $<br>1 November 20X4 - 8<br>1 February 20X5 - 9<br>31 October 20X5 - 9.5<br>Average for year to 31 October 20X5 - 8.5</p><input type='hidden' id='ExcelResponse' name='ExcelResponse'> <input type='hidden' id='WordResponse' name='WordResponse'> <input type='hidden' id='SlidesResponse' name='SlidesResponse'> <br><br></div>",
		requirementsText: {
			groups: [
				{
					id: 1,
					text: "Exhibits",
				},
				{
					id: 2,
					text: "Requirements",
				},
			],
			material: [
				{
					id: 1,
					groupID: 1,
					title: "Exhibit 1",
					content:
						"<p></p><p>On 1 June 20X8 Grange acquired a controlling interest of 60% of the equity interests of Park. The purchase consideration comprised cash of $250 million. At the acquisition date, the fair values of Park's net assets were the same as their carrying amounts except for the following two items:</p><ul><li>Non-depreciable land had a fair value of $80 million but was included in Park's statement of financial position at $75 million. This land was still held at 30 November</li><li>Park held a franchise right, which at 1 June 20X8 had a fair value of $10 million. The franchise right had not been recognised in the financial statements of Park. The franchise right had a remaining term of five years to run at the date of acquisition and is not Park still holds this franchise right at</li></ul><p>30 November 20X9.</p><p>Grange measures non-controlling interest (NCI) at fair value: the fair value of the NCI in Park was</p><p>$150 million on 1 June 20X8. At the date of acquisition, the equity section of Park's statement of financial position was as follows:</p><p style='text-align: center;'>$m</p><table><tbody><tr><td width='508'><p>Share capital</p></td><td width='19'><p>230</p></td></tr><tr><td width='508'><p>Retained earnings</p></td><td width='19'><p>115</p></td></tr><tr><td width='508'><p>Other components of equity</p></td><td width='19'><p>10</p></td></tr><tr><td width='508'><p>Total equity</p></td><td width='19'><p>355</p></td></tr></tbody></table><p>Grange acquired a further 20% equity interest in Park on 30 November 20X9 for cash consideration of</p><p>$90 million. At that date, Park's retained earnings were $170 million and other components of equity were $14 million.</p><p></p>",
				},
				{
					id: 2,
					groupID: 1,
					title: "Exhibit 2",
					content:
						"<p></p><p>On 30 June 20X8, Grange acquired a 100% equity interest in Sitin for a cash consideration of $39 million. Sitin's identifiable net assets had a fair value of $32 million at that date.</p><p>On 30 November 20X9, Grange disposed of 60% of its equity interest in Sitin, losing its controlling interest in Sitin from that date. The identifiable net assets of Sitin were $36 million at the date of disposal. The sale proceeds were $23 million and the remaining equity interest had a fair value of $13 million. The only accounting entry made in Grange's accounts for the year ended 30 November 20X9 was to increase cash and reduce the cost of the investment in Sitin by the amount of the sales proceeds. After the sale, there will continue to be significant transactions between Grange and Sitin.</p><p></p>",
				},
				{
					id: 3,
					groupID: 2,
					title: "Requirement 1",
					content:
						"<p></p><p>(i) Explain, with suitable workings, how the goodwill in relation to Park should be accounted for in the consolidated statement of financial position as at 30 November 20X9. Your answer should explain the treatment of the additional equity interest in Park which was acquired on 30 November</p><p><strong>(10 marks)</strong></p><p>(ii) Explain, with suitable workings, the appropriate accounting treatment for the sale of the shares in Sitin in the consolidated financial statements as at 30 November 20X9.&nbsp;</p><p><strong>(6 marks)</strong></p><p></p>",
				},
			],
		},
		questionTitle: "Question 7",
		isPrivate: 0,
		questionType: {
			questionTypeID: 6,
			questionTypeName: "MultiResponse",
		},
		questionUsedStatus: true,
		difficultyLevel: "Easy",
		questionMarks: 1.5,
		answers: [
			{
				answerID: 1,
				answerText: "Word Processor",
				extraFields: {
					answerMode: "word",
				},
				isCorrect: true,
			},
			{
				answerID: 2,
				answerText: "Spreadsheet",
				extraFields: {
					answerMode: "excel",
				},
				isCorrect: true,
			},
		],
		createdBy: {
			userID: 0,
			firstName: "admin",
			lastName: "admin",
			email: "admin@examtestingsystem.com",
		},
		categories: [
			{
				categoryID: 1,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 1",
				categoryType: "Question",
			},
			{
				categoryID: 2,
				parentID: null,
				sourceID: "cat1",
				categoryName: "Category 2",
				categoryType: "Question",
			},
		],
	},
];

const sampleQuestionCategories = [
	{
		categoryID: 1,
		parentID: null,
		childCategories: [
			{
				categoryID: 3,
				parentID: 1,
				childCategories: null,
				sourceID: "category3",
				categoryName: "C# Programming",
				categoryType: "Question",
				createdAt: "2022-04-16T14:57:13+05:00",
				updatedAt: null,
			},
			{
				categoryID: 4,
				parentID: 1,
				childCategories: null,
				sourceID: "category4",
				categoryName: "Java Programming",
				categoryType: "Question",
				createdAt: "2022-04-16T14:57:13+05:00",
				updatedAt: null,
			},
		],
		sourceID: "category1",
		categoryName: "Semester 1",
		categoryType: "Question",
		createdAt: "2022-04-16T14:57:13+05:00",
		updatedAt: null,
	},
	{
		categoryID: 2,
		parentID: null,
		childCategories: [],
		sourceID: "category2",
		categoryName: "Semester 2",
		categoryType: "Question",
		createdAt: "2022-04-16T14:57:13+05:00",
		updatedAt: null,
	},
	{
		categoryID: 5,
		parentID: null,
		childCategories: [],
		sourceID: "1",
		categoryName: "Test Change",
		categoryType: "Question",
		createdAt: "2022-04-16T13:25:36+00:00",
		updatedAt: null,
	},
	{
		categoryID: 6,
		parentID: null,
		childCategories: [],
		sourceID: "2",
		categoryName: "F5",
		categoryType: "Question",
		createdAt: "2022-04-16T17:36:35+00:00",
		updatedAt: "2022-04-16T18:08:42+00:00",
	},
];

const sampleQuestionCategoriesByParent = {
	1: [
		{
			categoryID: 4,
			parentID: 1,
			sourceID: "cat1",
			categoryName: "Sub Category 1",
			categoryType: "Question",
		},
		{
			categoryID: 5,
			parentID: 1,
			sourceID: "cat1",
			categoryName: "Sub Category 2",
			categoryType: "Question",
		},
	],
	2: [],
	3: [],
	4: [],
	5: [
		{
			categoryID: 6,
			parentID: 5,
			sourceID: "cat1",
			categoryName: "Sub Sub Category 1",
			categoryType: "Question",
		},
		{
			categoryID: 7,
			parentID: 5,
			sourceID: "cat1",
			categoryName: "Sub Sub Category 2",
			categoryType: "Question",
		},
	],
};

const sampleQuestionTypes = [
	{
		QuestionTypeID: 1,
		QuestionTypeName: "DragnDrop",
	},
	{
		QuestionTypeID: 2,
		QuestionTypeName: "FreeText",
	},
	{
		QuestionTypeID: 3,
		QuestionTypeName: "Hotspot",
	},
	{
		QuestionTypeID: 4,
		QuestionTypeName: "Radio",
	},
	{
		QuestionTypeID: 5,
		QuestionTypeName: "Checkbox",
	},
	{
		QuestionTypeID: 6,
		QuestionTypeName: "SingleSelect",
	},
	{
		QuestionTypeID: 7,
		QuestionTypeName: "MultiSelect",
	},
	{
		QuestionTypeID: 8,
		QuestionTypeName: "Blanks",
	},
	{
		QuestionTypeID: 9,
		QuestionTypeName: "Word",
	},
	{
		QuestionTypeID: 10,
		QuestionTypeName: "Excel",
	},
];

export {
	QuestionType,
	QuestionTypeText,
	QuestionDifficultyLevel,
	questionDifficultyLevelOptions,
	sampleQuestions,
	sampleQuestionCategories,
	sampleQuestionCategoriesByParent,
	sampleQuestionTypes,
};
